import * as PIXI from 'pixi.js';
import Config from './Config';

export default class Background extends PIXI.Container {
  constructor() {
    super();

    this.sprites = [];
  }

  onResourcesLoaded() {
    this.sprites = [
      new PIXI.TilingSprite(PIXI.Loader.shared.resources['bg5'].texture, Config.GAME_WIDTH, Config.GAME_HEIGHT),
      new PIXI.TilingSprite(PIXI.Loader.shared.resources['bg4'].texture, Config.GAME_WIDTH, Config.GAME_HEIGHT),
      new PIXI.TilingSprite(PIXI.Loader.shared.resources['bg3'].texture, Config.GAME_WIDTH, Config.GAME_HEIGHT),
      // new PIXI.TilingSprite(PIXI.Loader.shared.resources['bg2'].texture, Config.GAME_WIDTH, Config.GAME_HEIGHT),
      new PIXI.TilingSprite(PIXI.Loader.shared.resources['bg1'].texture, Config.GAME_WIDTH, Config.GAME_HEIGHT),
    ];

    this.addChild(...this.sprites);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ], viewport) {
    this.sprites[0].tilePosition.x = (-player.positionX * 0.1) % this.sprites[0].texture.width;
    this.sprites[1].tilePosition.x = (-player.positionX * 0.2) % this.sprites[1].texture.width;
    this.sprites[2].tilePosition.x = (-player.positionX * 0.3) % this.sprites[2].texture.width;
    this.sprites[3].tilePosition.x = (-player.positionX * 0.4) % this.sprites[3].texture.width;
  }
}
